export default "__VITE_ASSET__CW9YDzQB__"